import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from "@chakra-ui/react";
import { usePemateriContext } from "../../../../controller/admin/data_master/pemateri";

const ModalDeletePemateri: React.FC = () => {
    const {
        setPemateriState,
        handleDelete,
    } = usePemateriContext().dispatch;

    const {
        isOpenModalDeletePemateri,
        isLoadingSubmit,
    } = usePemateriContext().state;
    return (
        <>
            <Modal
                isOpen={isOpenModalDeletePemateri}
                onClose={() => setPemateriState('isOpenModalDeletePemateri', false)}
                size="2xl"
                isCentered
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader fontSize="lg" fontWeight="bold">
                        Hapus Pemateri
                    </ModalHeader>
                    <ModalCloseButton bgColor="red.400" color="white" />
                    <ModalBody px={6}>
                        <Text fontSize="sm">
                            Apakah Anda Yakin Ingin Menghapus Data Ini?
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="gray"
                            mr={3}
                            onClick={() => setPemateriState('isOpenModalDeletePemateri', false)}
                        >
                            Batal
                        </Button>
                        <Button
                            colorScheme="red"
                            isLoading={isLoadingSubmit}
                            isDisabled={isLoadingSubmit}
                            onClick={() => handleDelete()}
                        >
                            Yakin
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
export default ModalDeletePemateri;